module.exports = __webpack_public_path__ + "static/media/edit.37f0d57f.svg";